import React, { FC, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAction, useTranslationStrict } from 'out-game/hooks'
import { isServer } from 'out-game/constants'
import {
  setIsGeneralChatOpened,
  setIsNotificationsEnabled,
  setIsUserConnected,
  setUnreadMessages,
  setWsGeneralChat,
} from 'out-game/actions/ui/main'
import { GeneralChat } from 'GeneralChat'
import Button from './Button'
import { UserSubscription } from '../../types'

const ChatButton: FC = () => {
  const { t } = useTranslationStrict('menu')

  const setIsGeneralChatOpenedButton = useAction(setIsGeneralChatOpened)
  const setWsGeneralChatButton = useAction(setWsGeneralChat)
  const isGeneralChatOpened = useSelector(
    (state) => state.ui.main.isGeneralChatOpened
  )
  const wsGeneralChat = useSelector((state) => state.ui.main.wsGeneralChat)
  const user = useSelector((state) => state.data.user)
  const reqStateAll = useSelector((state) => state.requests)
  const isUserLoaded =
    reqStateAll.checkAuth === 'success' ||
    reqStateAll.checkAuth === 'failure' ||
    reqStateAll.auth1step === 'success'
  const subscriptions: UserSubscription[] | null = useSelector((state) => state.data.ownedSubscriptions)
  const [isSubscriptionExist, setIsSubscriptionExist] = useState(false)

  const setIsNotificationsEnabledButton = useAction(setIsNotificationsEnabled)
  const setIsUserConnectedButton = useAction(setIsUserConnected)
  const isNotificationsEnabled = useSelector(
    (state) => state.ui.main.isNotificationsEnabled
  )
  const isUserConnected = useSelector((state) => state.ui.main.isUserConnected)
  const setUnreadMessagesButton = useAction(setUnreadMessages)
  const isUnreadMessages  = useSelector(
    (state) => state.ui.main.isUnreadMessages 
  )

  useEffect(() => {
    if (!user?.subscription || !subscriptions?.length) return

    const userSubscription = subscriptions.find((item) => item.key === user.subscription) || null
    setIsSubscriptionExist(!!userSubscription?.active)
  }, [user?.subscription, subscriptions])

  return (
    <>
      <Button
        isChatOpened={isGeneralChatOpened}
        setIsChatOpened={setIsGeneralChatOpenedButton}
        setUnreadMessages={setUnreadMessagesButton}
        isUnreadMessages={isUnreadMessages}
      />
      {!isServer && isUserLoaded && (
        <GeneralChat
          setWsGeneralChat={setWsGeneralChatButton}
          wsGeneralChat={wsGeneralChat}
          setIsNotificationsEnabled={setIsNotificationsEnabledButton}
          setIsUserConnected={setIsUserConnectedButton}
          isNotificationsEnabled={isNotificationsEnabled}
          isUserConnected={isUserConnected}
          user={user ? user.nickname : null}
          isChatOpen={isGeneralChatOpened}
          setIsChatOpenedOuter={setIsGeneralChatOpenedButton}
          setUnreadMessages={setUnreadMessagesButton}
          isSubscriptionExist={isSubscriptionExist}
          title={t('floodroom')}
        />
      )}
    </>
  )
}

export default ChatButton
